// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingIndicator_spinner__Uvuhi"};